export enum AppQueryKeys {
    ORGANISATION_SPREADSHEETS = 'orgSheets',
    ORGANISATION_CHARTS = 'orgCharts',
    ORGANISATION_PRESETS = 'org-presets',
    SPREADSHEET = 'spreadsheet',
    SPREADSHEET_CHARTS = 'spreadsheetCharts',
    SHEET = 'sheet',
    SHEET_NAME = 'sheetName',
    PRESETS = 'presets',
    TAB = 'tab',
    ALL = 'all',
}
